import { ChangelogsNamespace } from '../../../stores/namespace';

export const ChangelogLogsNamespace = `${ChangelogsNamespace}/logs`;
